module.exports = __webpack_public_path__ + "static/assets/c12e386b8137e71b289edca2cca5e500.png";